export default {
      id: "contrast-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.68fd9e19.svg#contrast",
      toString: function () {
        return this.url;
      }
    }